import dayjs from "dayjs";
import Play from "../icons/Play";
import { FaceitLevel } from "./FaceitLevel";

export default ({
    player,
    lastGame,
    game,
    onRemove,
}: {
    player: any;
    lastGame?: any;
    game: any;
    onRemove: () => void;
}) => {
    const playing = player.status === "Ongoing";

    return (
        <div className="bg-gray rounded-md p-4 flex flex-col gap-3">
            {/* top row */}
            <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                    <img className="rounded-full" src={player.avatar} height="40" width="40" />
                    <div className="min-w-0">
                        <a
                            className="font-semibold truncate block"
                            href={player.faceit_url.replace("{lang}", "en")}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {player.nickname}
                        </a>

                        <div className="flex items-center gap-2 text-sm text-white/70">
                            <img
                                className="rounded-sm"
                                width="18"
                                height="14"
                                style={{ width: "18px", height: "14px" }}
                                src={`https://flagcdn.com/${player.country}.svg`}
                            />
                            <span className="w-5 h-5">
                                <FaceitLevel level={player.skill_level} />
                            </span>
                            <span>{player.elo} ELO</span>
                        </div>
                    </div>
                </div>

                <button
                    onClick={onRemove}
                    className="shrink-0 bg-primary-text rounded-md text-white px-3 py-2 text-sm"
                >
                    Remove
                </button>
            </div>

            {/* ban */}
            {player.ban !== null ? (
                <div className="border border-pink rounded-md px-3 py-2">
                    <span className="text-pink text-sm font-semibold">{String(player.ban).toUpperCase()}</span>
                </div>
            ) : null}

            {/* status */}
            {playing ? (
                <div className="border border-pink bg-pink rounded-md px-3 py-2 flex items-center justify-between gap-3">
                    <div className="bg-pink-dark rounded-md px-3 py-2 text-sm font-semibold flex items-center gap-2">
                        <span>Playing</span>
                        {game?.score ? (
                            <span>
                                {game.score}
                            </span>
                        ) : null}
                    </div>

                    <div className="text-sm flex items-center gap-2">
                        <span className="text-white/90">
                            {game?.type === "matchmaking" ? "5vs5 ranked" : game?.name}
                        </span>
                        {game?.url ? (
                            <a href={game.url} target="_blank" rel="noopener noreferrer">
                                <Play />
                            </a>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className="border border-pink rounded-md px-3 py-2">
                    <span className="text-pink text-sm">Last time played:</span>{" "}
                    <span className="text-sm">
                        {dayjs.utc(player.last_game_at).fromNow()}
                    </span>
                </div>
            )}
        </div>
    );
};